module.exports = __webpack_public_path__ + "img/4.924bdad8.jpg";